import React from 'react'
import { formatDate } from '../../utils/functions'

const ChequeCard = ({ cheque }) => {

    const { owner, amount, currency, deadline, serialNumber, bank, branch } = cheque


    return (
        <div className='shadow-md border rounded-md p-2 mb-1'>
            <label className='block'>Çek Sahibi : {owner} </label>
            <label className='block'>Tutar : {amount} {currency} </label>
            <label className='block'>Son Tarih : {formatDate(deadline)} </label>
            <label className='block'>Çek Numarası : {serialNumber} </label>
            <label className='block'>Banka : {bank} </label>
            <label className='block'>Şube : {branch} </label>
        </div>
    )
}

export default ChequeCard